import PropTypes from "prop-types";
import Button from "@mui/material/Button";

export default function CloseButton({ onClick }) {
  return (
    <Button
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "5px",
        right: "5px",
        color: "grey",
        minWidth: "0",
      }}
    >
      🗙
    </Button>
  );
}

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
